import { useRef, useState, type KeyboardEvent } from 'react';

type Props = {
  disabled: boolean;
  onSend: (text: string) => void;
  placeholder: string;
  ariaLabel: string;
  sendLabel: string;
};

export function Composer({ disabled, onSend, placeholder, ariaLabel, sendLabel }: Props) {
  const [value, setValue] = useState('');
  const ta = useRef<HTMLTextAreaElement>(null);

  function commit() {
    const trimmed = value.trim();
    if (!trimmed || disabled) return;
    onSend(trimmed);
    setValue('');
    ta.current?.focus();
  }

  function onKeyDown(e: KeyboardEvent<HTMLTextAreaElement>) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      commit();
    }
  }

  return (
    <form
      className="kb-composer"
      onSubmit={(e) => {
        e.preventDefault();
        commit();
      }}
    >
      <textarea
        ref={ta}
        className="kb-composer__input"
        rows={1}
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={onKeyDown}
        aria-label={ariaLabel}
        disabled={disabled}
      />
      <button
        type="submit"
        className="kb-composer__send"
        disabled={disabled || value.trim().length === 0}
        aria-label={sendLabel}
      >
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M2 9l14-7-7 14-2-5-5-2z" />
        </svg>
      </button>
    </form>
  );
}
